module.exports = __webpack_public_path__ + "static/media/knight.770cc9cd.png";